(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireaf93"];
var parcelRegister = parcelRequire.register;
parcelRegister("4tJTj", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $342d77e7d65bce78$export$b3890eb0ae9dca99; });

var $ap0Jw = parcelRequire("ap0Jw");

var $aYz74 = parcelRequire("aYz74");
function $342d77e7d65bce78$var$hideModal(modal) {
    if (!modal) return;
    // Hide the modal.
    modal.classList.remove("block");
    modal.classList.add("hidden");
    // Unlock the html and body scroll.
    document.documentElement.style.overflow = "auto";
    document.body.style.overflow = "auto";
}
function $342d77e7d65bce78$export$b3890eb0ae9dca99() {
    return $342d77e7d65bce78$var$_render.apply(this, arguments);
}
function $342d77e7d65bce78$var$_render() {
    $342d77e7d65bce78$var$_render = (0, $ap0Jw._)(function() {
        var modals, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
        return (0, $aYz74.__generator)(this, function(_state) {
            // Get all modals on the page
            modals = document.querySelectorAll(".frcg-modal");
            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                _loop = function() {
                    var modal = _step.value;
                    // Attach click on scrim to close modal
                    modal.addEventListener("click", function(e) {
                        if (e.target.classList.contains("frcg-modal")) $342d77e7d65bce78$var$hideModal(modal);
                    });
                    // Attach click on close button to close modal
                    var closeButtons = modal.querySelectorAll(".frcg-modal__close");
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = closeButtons[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var closeButton = _step1.value;
                            closeButton.addEventListener("click", function() {
                                $342d77e7d65bce78$var$hideModal(modal);
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // Attach click on open button to open modal, getting the toggledBy data attribute from the modal
                    var openButtonSelector = modal.getAttribute("data-toggled-by");
                    if (openButtonSelector) {
                        var openButton = document.querySelector(openButtonSelector);
                        if (openButton) openButton.addEventListener("click", function() {
                            modal.classList.add("block");
                            modal.classList.remove("hidden");
                        });
                    }
                };
                // Loop through the modals and add event listeners
                for(_iterator = modals[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                2
            ];
        });
    });
    return $342d77e7d65bce78$var$_render.apply(this, arguments);
}

});

})();
//# sourceMappingURL=modal.1051433f.js.map
